App.namespace.wrap('components.room_selection_tracking', () => {
  const targetTextNode = document.querySelector('.room__name').childNodes[0];

  const selectionChangeListener = () => {
    // not supported
    if (!document.getSelection) {
      return;
    }

    const selection = document.getSelection().toString().trim();

    // selection is empty - ignore
    if (!selection) {
      return;
    }

    // ignore selection to text that we don't track
    if (window.getSelection().anchorNode !== targetTextNode) {
      return;
    }

    App.track.all({
      category: 's-selection-leakage',
      action: 'room-h1',
      label: selection,
      value: window.__DATA_TRACKING_VAR__ROOM_ID,
      meta: JSON.stringify({
        selection,
        roomTag: window.__DATA_TRACKING_VAR__TAG_SLUG,
        roomId: window.__DATA_TRACKING_VAR__ROOM_ID,
      }),
    });
  };

  const selectionChangeListenerDebounced = App.es6.shared.debounce(
    selectionChangeListener,
    1000,
    false,
  );

  document.addEventListener('selectionchange', selectionChangeListenerDebounced);
});
